import React, { useState, useEffect } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import { API_URL } from "../../../../constants/index";
import moment from "moment";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";

const AttendanceApproval = () => {
  const [monthsOpt, setMonthsOpt] = useState([]);
  const [empOpt, setEmpOpt] = useState([]);
  const [attendanceMonths, setAttendanceMonths] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState({}); // index => value
  const [modalData, setModalData] = useState(null);


  const [showApproval, setShowApproval] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState();

  const [selectedEmp, setSelectedEmp] = useState(null);

  useEffect(() => {
    if (monthsOpt.length > 0) {
      fetchAttendanceDetails();
    }
  }, [monthsOpt]); // Make sure monthsOpt is in the dependency array




  const [apiStatus, setApiStatus] = useState('')
  const fetchAttendanceDetails = async (
    monthValue = monthsOpt[0]?.value,
    employeeId = 0
  ) => {
    setApiStatus(undefined);
    try {
      const response = await GetServiceCaller(
        `${API_URL}approve-attendance-details?current_date=${monthValue}&EmployeeID=${employeeId}`
      );

      setApiStatus(response?.status)
      if (response?.status === 200) {
        // Attendance Months
        const attendanceMonths = response?.data?.days || [];
        setAttendanceMonths(attendanceMonths);

        // Attendance Data
        const attendanceData = response?.data?.data || [];
        setAttendanceData(attendanceData);

        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error making GET request", error);
    }
  };
  useEffect(() => {
    fetchAttendanceMonths();
  }, []);

  const fetchAttendanceMonths = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}approve-attendance`);

      // Months options List
      const Months = response?.data?.month || "";
      const monthsOpt = Months?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setMonthsOpt(monthsOpt);
      setSelectedMonth(monthsOpt[0]);
      // Employee options List
      const Employee = response?.data?.employee;
      const EmpOpt = Employee?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setEmpOpt(EmpOpt);
    } catch (error) {
      console.error("Error making Post request", error);
    }
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Attendance Approval"));
  }, []);

  const tableHeaders = Object.keys(attendanceMonths || {})
    .filter((key) => key !== "Name" && key !== "Action")
    .map((date) => date); // Keep the full date format

  const renderTableHeader = () => {
    if (tableHeaders.length === 0) {
      return (
        <th colSpan="2" style={{ textAlign: "center" }}>
          No records found
        </th>
      );
    }


    return (
      <>
        <th>Employee</th>
        {tableHeaders.map((date, index) => {
          const cleanedValue =
            attendanceMonths?.[date]?.replace(/<[^>]+>/g, "") || "";
          const charPart = cleanedValue.charAt(0) || ""; // First letter
          const numPart = cleanedValue.substring(1) || ""; // Remaining numbers

          return (
            <th key={index} className="text-center">
              <div>{charPart}</div>
              <div>{numPart}</div>
            </th>
          );
        })}
        <th>Action</th>
      </>
    );
  };

  const handleClick = (value) => {
    if (value.startsWith("P") || value.startsWith("A_")) {
      const parts = value.split("_");
      const TXNID = parts[1];
      const LineNo = parts[2];

      setSelectedValue(value);
      setShowModal(true);

      PostServiceCaller(`${API_URL}view-data`, { TXNID, LineNo }, "post")
        .then((response) => {
          const data = response?.data?.data;
          setModalData(data?.map(o => ({ ...o, daystatus: o.DayStatus ? o.DayStatus : 1 })));
        })
        .catch((error) => {
          console.error("Error making Post request", error);
        });
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedValue(null);
  };
  const StatusOpt = [
    { value: 1, label: "Present" },
    { value: 0, label: "Absent" },
  ];

  const handleStatusChange = (value, index) => {
    // update modalData DayStatus
    setModalData((prev) => {
      const updatedData = [...prev];
      updatedData[index] = {
        ...updatedData[index],
        daystatus: value.value,
      };
      return updatedData;
    });

    // update selectedStatus separately
    setSelectedStatus((prev) => ({
      ...prev,
      [index]: value.value,
    }));
  };

  const handleStatusSubmit = async (item, index) => {

    const status = selectedStatus[index];

    if (status == null) {
      return toast.error("Please select a valid status");
    }

    const payload = {
      daystatus: status,
      employeeID: item.EmployeeID,
      rowstatus: 436,
      attendancestatus: 824,
      dates: moment(item.date).format("YYYY-MM-DD"),
      MonthID: selectedMonth?.value,
    };

    try {
      const response = await PostFormServiceCaller(
        `${API_URL}mark-attendance`,
        payload
      );
      toast.success("Attendance status changed successfully!");
      fetchAttendanceDetails();
      setShowModal(false);
    } catch (error) {
      console.error("Error submitting data", error);
    }
  };


  const handleAttendanceApprove = (employee) => {

    setSelectedEmployee(employee);
    setShowApproval(true);
  };



  const [isSubmittingApproval, setIsSubmittingApproval] = useState(false);

  const handleApprove = () => {
    if (!selectedEmployee) {
      console.error("No employee selected.");
      return;
    }
    setIsSubmittingApproval(true)
    // Extract valid dates (excluding "WO" and "HOL")
    const validDates = Object.keys(selectedEmployee)
      .filter((key) => key.match(/^\d{2}-[A-Za-z]{3}-\d{4}$/)) // Matches date format
      .filter(
        (key) =>
          selectedEmployee[key] !== "WO" && selectedEmployee[key] !== "HOL"
      ); // Exclude "WO" & "HOL"

    const payload = {
      daystatus: 1.0,
      employeeID: selectedEmployee.id,
      rowstatus: 436,
      remark: document.getElementById("remark").value,
      attendancestatus: 826,
      dates: validDates.join(", "),
      MonthID: selectedMonth.value,
    };


    // API call
    PostFormServiceCaller(`${API_URL}manager-mark-attendance`, payload)
      .then((response) => {
        toast.success("Attendance approved successfully!");
        setShowApproval(false);
        setIsSubmittingApproval(false)
        fetchAttendanceDetails();
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsSubmittingApproval(false)
      });
  };
  // const handleGetData = () => {
  //   fetchAttendanceDetails(selectedMonth?.value, selectedEmp?.value);
  // };
  const handleGetData = () => {
    const month = selectedMonth?.value || monthsOpt[0]?.value;
    const empId = selectedEmp?.value || 0;

    fetchAttendanceDetails(month, empId);
  };

  useEffect(() => {
    if (monthsOpt.length > 0 && !selectedMonth) {
      setSelectedMonth(monthsOpt[0]);
    }
  }, [monthsOpt]);
  const handleReset = () => {
    // Reset to initial state
    setSelectedEmployee(null);
    fetchAttendanceMonths()
    setSelectedMonth(monthsOpt[0]);    // window.location.reload();
  };
  const getFormattedName = (name) => {
    const parts = name.trim().split(" ");
    const firstName = parts[0];
    const lastNameInitial = parts.length > 1 ? parts[parts.length - 1][0] + "." : "";
    return `${firstName} ${lastNameInitial}`;
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <div className="d-flex flex-column flex-md-row gap-2">
              <div className="col-md-2">
                <label for="leave-type" class="form-label">
                  Month
                </label>
                <Select
                  options={monthsOpt}
                  onChange={setSelectedMonth}
                  value={selectedMonth}
                />
              </div>

              <div className="col-md-2">
                <label for="leave-type" class="form-label">
                  Employee
                </label>
                <Select
                  options={empOpt}
                  onChange={setSelectedEmp}
                  value={selectedEmp}
                />
              </div>

              <div className="col-md-8 text-end mt-0 mt-md-4 px-md-3">
                <button className="custom-btn me-2" onClick={handleReset}>
                  Reset
                </button>
                <button className="custom-btn" onClick={handleGetData}>
                  Get Data
                </button>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            {isLoading ? (
              <div className="d-flex justify-content-center align-items-center">
                <p>
                  <FaSpinner className="spinner" spin />
                  <br />
                  Loading
                </p>
              </div>
            ) : (
              <div className="container-fluid">
                <div style={{ overflowX: "auto" }}>
                  <Table striped bordered hover>
                    <thead id="thcolor" className="text-center">
                      <tr>{renderTableHeader()}</tr>
                    </thead>
                    <tbody>
                      {apiStatus === 200 && attendanceData?.length > 0 ? (
                        attendanceData?.map((employee, idx) => (
                          <tr key={idx}>
                            <td>{employee.Name}</td>
                            {tableHeaders.map((date, index) => {
                              const cellValue = employee[date];
                              const workReq = employee.work_requests ? employee.work_requests[date] : null;
                              let cellClass = "";
                              let cellStyle = {};

                              if (
                                cellValue &&
                                cellValue.startsWith("P_") &&
                                cellValue.endsWith("_1")
                              ) {
                                // Approved Present
                                cellStyle.color = "#616161"; // Gray
                              } else if (
                                cellValue &&
                                cellValue.startsWith("A_") &&
                                cellValue.endsWith("_1")
                              ) {
                                // Approved Absent
                                cellStyle.color = "#616161"; // Gray
                              } else if (
                                cellValue &&
                                cellValue.startsWith("P_") &&
                                !cellValue.endsWith("_1")
                              ) {
                                // Pending Present - Black
                                cellClass = "fw-bold";
                                cellStyle.color = "#000000"; // Bold
                              } else if (
                                cellValue &&
                                cellValue.startsWith("A_") &&
                                !cellValue.endsWith("_1")
                              ) {
                                // Pending Absent - red
                                cellStyle.color = "#FF0000"; // Red Bold
                                cellClass = "fw-bold";
                              }

                              const mainStatus = cellValue && cellValue.startsWith("P_")
                                ? "P"
                                : cellValue && cellValue.startsWith("A_")
                                  ? "A"
                                  : cellValue || "-";

                              return (
                                <td
                                  key={index}
                                  onClick={() => {
                                    if (cellValue && !cellValue.endsWith("_1")&&!cellValue.startsWith("PL")) {
                                      handleClick(cellValue);
                                    }
                                  }}
                                  className={`text-center ${cellClass}`}
                                  style={{
                                    cursor:
                                      cellValue && !cellValue.endsWith("_1")
                                        ? "pointer"
                                        : "default",
                                    ...cellStyle,
                                  }}
                                >
                                  {workReq ? (
                                    <div className="d-flex flex-column align-items-center justify-content-center py-0" style={{ lineHeight: "1.1" }}>
                                      <span>{mainStatus === "-" ? "P" : mainStatus}</span>
                                      <span
                                        className="fw-bold text-primary"
                                        style={{ fontSize: "9px", marginTop: "1px", lineHeight: "1" }}
                                      >
                                        {workReq}
                                      </span>
                                    </div>
                                  ) : (
                                    mainStatus
                                  )}
                                </td>
                              );
                            })}
                            <td className="text-center">
                              <i
                                className={`fa fa-check ${tableHeaders.some((date) => {
                                  const val = employee[date];
                                  return (
                                    val &&
                                    (val.startsWith("P_") ||
                                      val.startsWith("A_")) &&
                                    !val.endsWith("_1")
                                  );
                                })
                                  ? "text-primary"
                                  : "text-secondary disabled-approve-icon"
                                  }`}
                                style={{
                                  cursor: tableHeaders.some((date) => {
                                    const val = employee[date];
                                    return (
                                      val &&
                                      (val.startsWith("P_") ||
                                        val.startsWith("A_")) &&
                                      !val.endsWith("_1")
                                    );
                                  })
                                    ? "pointer"
                                    : "default",
                                }}
                                onClick={() => {
                                  if (
                                    tableHeaders.some((date) => {
                                      const val = employee[date];
                                      return (
                                        val &&
                                        (val.startsWith("P_") ||
                                          val.startsWith("A_")) &&
                                        !val.endsWith("_1")
                                      );
                                    })
                                  ) {
                                    handleAttendanceApprove(employee);
                                  }
                                }}
                              ></i>
                            </td>
                          </tr>
                        ))
                      ) : apiStatus === 200 && attendanceData?.length === 0 ? (
                        <tr>
                          <td
                            colSpan={tableHeaders.length + 2}
                            className="text-center"
                          >
                            No Data Found
                          </td>
                        </tr>
                      ) : apiStatus === undefined && attendanceData?.length === 0 ? (
                        <tr>
                          <td
                            colSpan={tableHeaders.length + 2}
                            className="text-center"
                          >
                            <FaSpinner className="spinner" />
                          </td>
                        </tr>
                      ) : apiStatus === undefined ? (
                        <tr>
                          <td
                            colSpan={tableHeaders.length + 2}
                            className="text-center"
                          >
                            <FaSpinner className="spinner" />
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td
                            colSpan={tableHeaders.length + 2}
                            className="text-center"
                          >
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}
            {showModal && (
              <div
                className="modal"
                tabIndex="-1"
                role="dialog"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                }}
              >
                <div
                  className="modal-dialog modal-sm modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-body">
                      <div className="d-flex justify-content-between">
                        <h5>
                          <b>
                            <i className="bi bi-pencil-fill"></i>Attendance Edit
                          </b>
                        </h5>
                        <div>
                          <div onClick={handleClose}>
                            <i className="bi bi-x-lg"></i>
                          </div>
                        </div>
                      </div>

                      {modalData && modalData.length > 0 ? (
                        modalData.map((item, index) => (
                          <div key={index}>
                            <div className="row mt-2">
                              <div className="col-6"><b>Date</b></div>
                              <div className="col-6">: {moment(item.date).format("DD-MMM-YYYY")}</div>
                            </div>

                            <div className="row mt-2">
                              <div className="col-6"><b>Status</b></div>
                              <div className="col-6">: {item.ATSDayStatus}</div>
                            </div>

                            <div className="row mt-2">
                              <div className="col-6"><b>Confirmed</b></div>
                              <div className="col-6">: {item.IsConfirmed === 1 ? "Yes" : "No"}</div>
                            </div>

                            <div className="row mt-3">
                              <div className="col-6">
                                <Select
                                  options={StatusOpt}
                                  value={StatusOpt?.find(o => o.value === parseInt(item.daystatus))}
                                  onChange={(value) => handleStatusChange(value, index)}
                                />
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => handleStatusSubmit(item, index)}
                                  className="custom-btn"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>Loading</p>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Approve Attendance */}
            {showApproval && (
              <div
                className="modal"
                tabIndex="-1"
                role="dialog"
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 1050
                }}
              >
                <div
                  className="modal-dialog modal-sm"
                  role="document"
                  style={{
                    width: "300px", // Standard width for modal-sm
                    margin: 0 // Remove default margin
                  }}
                >
                  <div className="modal-content">
                    {/* <div className="modal-header d-flex justify-content-between">
                      <h6 className="heading skill-heading">
                        Approve Attendance
                      </h6>
                      <button
                        className="custom-btn"
                        onClick={() => setShowApproval(false)}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                    </div> */}
                    <div className="modal-header" style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      borderBottom: '1px solid #f0f0f0',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px 8px 0 0'
                    }}>
                      <p style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#27568B',
                        margin: '0'
                      }}>{`Approve Attendance (${getFormattedName(selectedEmployee.Name)})`}</p>
                      <button
                        onClick={() => setShowApproval(false)}
                        style={{
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          fontSize: '18px',
                          color: '#000',
                          padding: '4px',
                          borderRadius: '4px',
                          transition: 'all 0.2s',
                          lineHeight: '1'
                        }}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                    </div>

                    <div className="modal-body p-2">
                      {selectedEmployee ? (
                        <>

                          <div className="row">
                            <div className="col-md-12">
                              <textarea
                                type="text"
                                className="form-control"
                                id="remark"
                                name="remark"
                                placeholder="Remark"
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <p>No data available</p>
                      )}
                    </div>
                    <div className="text-end p-2">
                      <button
                        type="button"
                        className="cancel-btn-sm me-2"
                        onClick={() => setShowApproval(false)}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="custom-btn-sm"
                        onClick={handleApprove}
                        disabled={isSubmittingApproval} // prevent double clicks
                      >
                        {isSubmittingApproval ? (
                          <FaSpinner className="spinner-sm" />
                        ) : (
                          "Approve"
                        )}
                      </button>

                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceApproval;
